











import { Component, Vue } from 'vue-property-decorator';
import HomeTop from './Top.vue';
import HomeIntroduction from './Introduction.vue';
import HomeStat from './Stat.vue';
import HomeFields from './Fields.vue';
import HomeTestimonials from './Testimonials.vue';
import HomeDesigned from './Designed.vue';

@Component({
  components: {
    HomeTop,
    HomeIntroduction,
    HomeStat,
    HomeFields,
    HomeTestimonials,
    HomeDesigned
  },
})
export default class Home extends Vue {}
